import React from 'react';
import { useTranslation } from 'react-i18next';

const ErrorMessage = ({ message }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-red-900/50 border border-red-700 text-red-300 px-4 py-3 rounded-lg" role="alert">
      <strong className="font-bold">{t('Error: ')}</strong>
      <span className="block sm:inline">{message}</span>
    </div>
  );
};

export default ErrorMessage;
